<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12">
        <base-material-card
          icon="mdi-map-check"
          :title="
            id ? $i18n.t('Edit zone - ') + zone.name : $i18n.t('Create zone')
          "
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-form id="form" ref="form" v-model="valid">
            <v-container class="py-0">
              <v-row>
                <v-col cols="4" style="margin-top: 17px">
                  <v-text-field
                    :label="$i18n.t('Zone Name') + '*'"
                    :rules="validationrules.name"
                    required
                    dense
                    v-model="zone.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="4" style="margin-top: 17px">
                  <v-text-field
                    :label="$i18n.t('Description')"
                    dense
                    v-model="zone.desc"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <z-country-select
                    class="purple-input"
                    v-model="zone.country"
                  ></z-country-select>
                </v-col>
              </v-row>
            </v-container>

            <v-container class="py-0">
              <v-row>
                <v-col>
                  <z-client-select
                    :label="$i18n.t('Client(s)')"
                    class="purple-input"
                    v-model="zone.clients"
                    multiple
                  ></z-client-select>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col>
                  <z-vendor-select
                    :label="$i18n.t('Suppliers(s)')"
                    class="purple-input"
                    v-model="zone.vendors"
                    multiple
                  ></z-vendor-select>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col>
                  <z-city-select
                    :label="$i18n.t('City')"
                    class="purple-input"
                    v-model="zone.cities"
                    :country="zone.country"
                    multiple
                  ></z-city-select>
                </v-col>
              </v-row>
            </v-container>

            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  valid = true;
  zone = {
    name: "",
    desc: "",
    version: null,
    _id: null,
    clients: [],
    vendors: [],
    cities: [],
  };
  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    startTime: [(v) => !!v || this.$i18n.t("Start Time is required")],
    endTime: [(v) => !!v || this.$i18n.t("End Time is required")],
  };
  id = null;

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      // console.log(this.zone);
      common.setLoading(true);
      this.zone = await doPost("/api/zone/save", this.zone);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      if (!this.id) this.$router.push("/settings/zone/" + this.zone._id);
      this.get(this.zone._id);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.zone = await doGet("/api/zone/" + id + "/detail");
      this.id = this.zone._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>

<style scoped>
.week-button {
  padding: 5px 4px;
  height: 30px;
  width: 30px;
  justify-content: center;
}
</style>
